// Dependecies
import { useState, useEffect } from 'react';


function useFormInProcess(id, setValue, watch, dataForm = null, quotation,img_quotation) {

    const [idService, setIdService] = useState(img_quotation ? JSON.parse(img_quotation) : []);
    const [validateFile, setValidateFile] = useState(false);

    const changeDataFormInApproval = () => {
        const dataValues = watch();
        if(dataForm){
            dataForm(dataValues);
        }
    };

    const handleImageChange = (e, field) => {
        setValidateFile(false);
        const newFiles = Array.from(e.target.files);
        const existingFiles = watch(field) || [];

        const validFiles = newFiles.filter((file) => {
            const { size, type } = file;
            const isValidType = ['image/png', 'image/jpg', 'image/jpeg', 'application/pdf'].includes(type);
            const isValidSize = size <= 6291456; // 6MB

            return isValidType && isValidSize;
        });

        if (validFiles.length === 0) {
            setValidateFile(true);
            return;
        }

        const combinedFiles = [...existingFiles, ...newFiles];
        setValue(field, combinedFiles);
        changeDataFormInApproval();
    };

    const handleKmOdometerChange = (e) => {
        const value = e.target.value.replace(/[^0-9]/g, '');
        setValue(`kmOdometer_${idService}`, value);
        changeDataFormInApproval();
    };

    const removeImage = (field, index) => {
        const currentImages = watch(field) || [];
        const updatedImages = currentImages.filter((_, i) => i !== index);
        setValue(field, updatedImages);
        changeDataFormInApproval();
    };
 

    useEffect(() => {
        if (id !== idService) {
            setIdService(id);
        }
    }, [id]);

    return {
        handleImageChange,
        handleKmOdometerChange,
        removeImage,
        idService,
        validateFile,
    };
}

export default useFormInProcess;
